import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox } from './CheckBox';
class DBCheckBox extends React.Component {



    handleClick(checked) {
        if (!this.props.disabled === true) {
            if (this.props.value) {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field)
            } else {
                this.props.updateBitField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, !this.props.value)
            }
            if (this.props.onClick) {
                this.props.onClick(!this.props.value);
            }
        }
    }

    render() {
        return (
            <CheckBox
                title={this.props.title}
                size={this.props.size}
                className={this.props.className}
                checked={this.props.value}
                label={this.props.label}
                disabled={this.props.disabled}
                onClick={() => this.handleClick()}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {


    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : false,
        disabled: ownprops.disabled !== undefined ? ownprops.disabled : false,
    };
}

const connectedDBCheckBox = connect(mapStateToProps, mapDispatchToProps)(DBCheckBox);
export { connectedDBCheckBox as DBCheckBox };